module.exports = {"TXTWCL_Meetings":{"id":"TXTWCL_Meetings","defaultMessage":"Stævner"}}